export default __webpack_public_path__ + "static/media/Thorsten Lünborg.37d06c82.png";